import { useModalPromise } from '@cp/shared/modal';
import { CatalogItemListRequest } from '@common/model/catalog/item/list.request';
import { Result } from '@cp/shared/result';
import { RELEVANT_CATALOG_ITEMS_MODAL } from '../lib';

/**
 * Запускает анимацию поиска анкет-вакансий
 */
export const useRelevantCatalogItemsAnimation = () => {
  const runModal = useModalPromise(RELEVANT_CATALOG_ITEMS_MODAL);
  return (request: CatalogItemListRequest, pause = 500) => Result.fromAsync(() => runModal({ request, pause }));
};
